import React from "react";
import styled from "styled-components";
import { ninja } from "@vitalsource/vstui/colors";
import { connect } from "react-redux";
import Swimlane from "../../../../components/swimlane";
import BookGrid from "../../bookviews/book-grid";
import { selectors as booksSelectors } from "../../../../../redux/books";
import { selectors as bridgeSelectors } from "../../../../../redux/bridge";
import {
  selectors as routerSelectors,
  actions as routerActions
} from "../../../../../redux/router";
import { isRelativeURL } from "../../../../../redux/router/utils";
import { selectors as userSelectors } from "../../../../../redux/user";
import {
  actions,
  selectors as searchSelectors,
  types as searchTypes
} from "../../../../../redux/search";
import { actions as uiLibraryActions } from "../../../../../redux/ui/library";
import { actions as bridgeActions } from "../../../../../redux/bridge";
import createScrollAction from "../../../../components/swimlane/create-scroll-action";
import { EDGE_SPACING, EDGE_SPACING_MED } from "../../bookviews/consts";
import ResultCard, { RESULT_WIDTH } from "./result-card";
import CategoryHead from "../../../../components/categoryhead";
import { styledMedia } from "../../../../components/mediaquery/breakpoints";
import CenteredSpinner from "../../../../components/spinner/centered-spinner";
import { XLarge, Tag } from "@vitalsource/vstui-icons";
import { Button } from "@vitalsource/vstui/";
import { t, Translation } from "../../../../core/translate";
import { OffScreenComponent } from "../../../../components/mixins";
import Link from "../../../../components/link";
import ZeroSearchResults from "../../../../components/icons/ZeroSearchResults";
import LicensedBook from "../../book/licensed-book";
import BridgeBook from "../../book/bridge-book";
import StoreBook from "../../book/store-book";
import { gaEvent } from "../../../../utils/analytics";
import PageTitle from "../../../../utils/page-title";
import { ssoToOldOnlineURL } from "../../../../utils/location";
import { cloud } from "@vitalsource/vstui/colors";
import { NAV_HEADER_HEIGHT } from "../../header/index";
import { getStoreSearchUrl } from "../../../../../redux/brand/selectors";

// So the focus rects and shadows are not cut off
const FUDGE_FACTOR = 5;

const BRIDGE_SEARCH_SIZE = 25;
const RESULT_MARGIN = 9;

const TITLE_BOTTOM_LG = 27;
const TITLE_BOTTOM_MD = 19;
const TITLE_BOTTOM_SM = 22;

const CheckStore = styled.div`
  text-align: center;
  font-size: 1.6rem;
  padding: 40px;
  background: ${cloud.getShade(3)};
  .explore-button {
    margin-top: 15px;
  }
`;

const SearchScreenContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  ${props =>
    props.position &&
    `
    height: calc(100vh - ${NAV_HEADER_HEIGHT + "px"});
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overflow-wrap: break-word;
  `}
`;

const TitleWrapper = styled.div`
  padding: 85px 110px ${TITLE_BOTTOM_LG}px ${EDGE_SPACING}px;
  background-color: ${ninja.getShade(11)};
  color: #fff;
  position: relative;
  font-size: 4.6rem;

  ${styledMedia.medium`
    font-size: 3.6rem;
    padding: 83px 80px ${TITLE_BOTTOM_MD}px 32px;
  `};
  ${styledMedia.small`
    font-size: 2.4rem;
    padding: 54px 70px ${TITLE_BOTTOM_SM}px 22px;
  `};
`;

const SearchHeader = styled.h1`
  font-size: inherit;
  font-weight: 400;
  margin: 0;
`;

const ExitButton = styled(Link)`
  position: absolute;
  bottom: ${TITLE_BOTTOM_LG}px;
  right: 43px;
  background: none;
  border: none;
  font-size: inherit;
  vertical-align: baseline;
  padding: 0;
  color: white;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8);
  }

  ${styledMedia.medium`
    bottom: ${TITLE_BOTTOM_MD}px;
    right: 30px;
  `} ${styledMedia.small`
    bottom: ${TITLE_BOTTOM_SM}px;
    right: 23px;
  `}

  svg {
    width: 24px;
    height: 24px;
    vertical-align: baseline;
    ${styledMedia.medium`
      width: 20px;
      height: 20px;
    `};
  }
`;

const ResultsHeader = styled.h2`
  padding-left: ${EDGE_SPACING}px;
  padding-top: 39px;
  padding-bottom: ${25 - FUDGE_FACTOR}px;
  ${styledMedia.medium`
    padding-left: ${EDGE_SPACING_MED}px;
    padding-top: 23px;
    padding-bottom: ${15 - FUDGE_FACTOR}px;
  `};
  ${styledMedia.small`
    padding-top: 30px;
    padding-bottom: ${17 - FUDGE_FACTOR}px;
  `};
`;

const OneContentResultWrapper = styled.li`
  padding: 0 ${RESULT_MARGIN}px;
  padding-top: ${FUDGE_FACTOR}px;

  &:first-child {
    padding-left: ${EDGE_SPACING}px;

    ${styledMedia.medium`
      padding-left: ${EDGE_SPACING_MED}px;
    `};
  }

  &:last-child {
    padding-right: ${EDGE_SPACING}px;

    ${styledMedia.medium`
      padding-right: ${EDGE_SPACING_MED}px;
    `};
  }
`;

const BigLoadingBlock = styled.div`
  height: 300px;
  margin: 0 ${EDGE_SPACING}px;

  ${styledMedia.medium`
    margin: 0 ${EDGE_SPACING_MED}px;
  `};
`;

const NoResultsContainer = styled.div`
  text-align: center;
  padding: 25px 0px;

  ${styledMedia.medium`
    padding: 50px;
  `};
`;

const NoResultsImageContainer = styled.div`
  svg {
    width: 100%;
    max-width: 700px;
    height: auto;
  }
`;

const NoResultsHeader = styled.p`
  font-size: 2.8rem;
  font-weight: 700;
  margin: 56px 0 14px;
`;

const NoResultsDetail = styled.p`
  font-size: 1.6rem;
  margin: 0;
`;

const VitalsourceLink = styled.a`
  color: this.props.theme.color.primary.getShade(6);
  font-size: 20px;
  ${styledMedia.small`
    font-size: 16px;
  `}
`;

const LibraryResultsContainer = styled.div`
  padding-bottom: 40px;
`;

const BookStoreHeadContainer = styled.div`
  ${styledMedia.small`
    font-size: 16px;
    padding: 14px 0 0 20px;
  `}
`;

class SearchScreen extends React.Component {
  componentDidMount() {
    this.props.performSearch(this.props.query);
    this.props.metadataSearch(this.props.query, false);
    this.props.bookStoreSearch(this.props.query);
    if (this.props.isBridgeUser) {
      this.props.searchBridge(this.props.query);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.query !== prevProps.query ||
      this.props.isBridgeUser !== prevProps.isBridgeUser
    ) {
      this.props.performSearch(this.props.query);
      this.props.metadataSearch(this.props.query, false);
      this.props.bookStoreSearch(this.props.query);
      if (this.props.isBridgeUser) {
        this.props.searchBridge(this.props.query);
      }
    }
  }

  exitSearch = e => {
    // if not relative url, don't allow and redirect to root
    if (!isRelativeURL(this.props.redirectOnClose)) {
      e.preventDefault();
      this.props.redirectToRoot();
    }
  };

  updateScrollPos = createScrollAction(() =>
    this.props.loadNextPage(this.props.query)
  );

  swimlaneInfoChange = data => {
    if (!data.canScroll) {
      this.props.loadNextPage(this.props.query);
    }
  };

  openSearchPanel = book => {
    this.props.openSearchPanel(book.isbn, t("base.search"));
  };

  loadMoreBridgeResults = () => {
    if (this.props.isBridgeUser) {
      this.props.searchMoreBridge(this.props.query);
    }
  };

  renderSpinner() {
    return (
      <BigLoadingBlock>
        <CenteredSpinner />
      </BigLoadingBlock>
    );
  }

  renderOneContentResult({ i, inView }) {
    const book = this.props.results[i];
    return (
      <OneContentResultWrapper key={book.isbn}>
        <ResultCard
          book={book}
          fullRender={inView}
          onClick={this.openSearchPanel}
        />
      </OneContentResultWrapper>
    );
  }

  renderContentResults() {
    const { results, isNative } = this.props;
    if (results.length === 0 || isNative) {
      return null;
    }

    return (
      <div>
        <ResultsHeader>
          <CategoryHead label={t("search.content-my-books")} />
        </ResultsHeader>
        <Swimlane
          renderItem={this.renderOneContentResult.bind(this)}
          averageItemWidth={RESULT_WIDTH + RESULT_MARGIN * 2}
          itemCount={results.length}
          onScroll={this.updateScrollPos}
          onInfoChange={this.swimlaneInfoChange}
        />
      </div>
    );
  }

  renderTitleResults() {
    if (
      this.props.metadataResults.length === 0 &&
      (this.props.isSearchingMetadata || this.props.isSearchingBridge)
    ) {
      return this.renderSpinner();
    }
    if (this.props.metadataResults.length === 0) {
      return null;
    }

    return (
      <LibraryResultsContainer>
        <BookGrid
          isbns={this.props.metadataResults.map(b => ({
            isbn: b.isbn || b.vbid,
            bookObject:
              b.source === searchTypes.LICENSE_SOURCE
                ? LicensedBook
                : BridgeBook
          }))}
          headerLabel={t("search.book-matches")}
          count={this.props.metadataResults.length}
          tryLoadMore={this.loadMoreBridgeResults}
        />
        {this.props.isSearchingNewBridgePage && this.renderSpinner()}
      </LibraryResultsContainer>
    );
  }

  renderBookStoreResults() {
    if (
      this.props.bookStoreResults.length === 0 &&
      (this.props.isSearchingMetadata || this.props.isSearchingBridge)
    ) {
      return this.renderSpinner();
    }
    if (this.props.bookStoreResults.length === 0) {
      return null;
    }
    return (
      <div>
        <BookGrid
          isbns={this.props.bookStoreResults.map(b => ({
            isbn: b.isbn || b.vbid,
            bookObject: StoreBook
          }))}
          headerLabel={t("library.store-book-matches", "Store Book Matches")}
          count={this.props.bookStoreResults.length}
          tryLoadMore={this.loadMoreBridgeResults}
          actionLink={
            <BookStoreHeadContainer>
              {this.props.vitalsourceUrl && (
                <VitalsourceLink
                  href={this.props.vitalsourceUrl}
                  target="_blank"
                >
                  {t(
                    "explore.view-more-results-on-vitalsource",
                    "View more results on Vitalsource.com"
                  )}
                </VitalsourceLink>
              )}
            </BookStoreHeadContainer>
          }
        />
        {this.props.isSearchingNewBridgePage && this.renderSpinner()}
      </div>
    );
  }

  renderMainContent() {
    if (
      (this.props.isSearchingMetadata &&
        !this.props.paginatedResults &&
        this.props.paginatedResults.isSearching) ||
      this.props.bridgeUserFetching ||
      this.props.isSearchingBookStore
    ) {
      return this.renderSpinner();
    }
    if (this.checkZeroResults()) {
      return (
        <NoResultsContainer>
          <NoResultsImageContainer>
            <ZeroSearchResults />
          </NoResultsImageContainer>
          <NoResultsHeader>
            <Translation id="errors.nothing-here" />
          </NoResultsHeader>
          <NoResultsDetail>
            <Translation id="search.check-spelling" />
          </NoResultsDetail>
        </NoResultsContainer>
      );
    }
    return (
      <div>
        {this.renderContentResults()}
        {this.renderTitleResults()}
        {!this.props.isNative && this.renderBookStoreResults()}
      </div>
    );
  }

  renderStoreFooter() {
    if (this.checkZeroResults() && this.props.storeUrl) {
      return (
        <CheckStore>
          <div>
            <Translation id="search.not-finding">
              Not finding what you’re looking for?
            </Translation>
          </div>
          <div>
            <Translation id="search.check-store" query={this.props.query} />
          </div>
          <Button
            iconStart={<Tag />}
            onClick={e => {
              e.preventDefault();
              gaEvent("BTS Store 2019", "click", "null_search_storebutton");
              ssoToOldOnlineURL(this.props.storeUrl, true, this.props.user);
            }}
            href={this.props.storeUrl}
            className={"explore-button"}
          >
            <Translation id="search.explore-vitalsource" />
          </Button>
        </CheckStore>
      );
    }
  }

  checkZeroResults() {
    if (this.props.isNative) {
      return (
        !this.props.paginatedResults || this.props.paginatedResults.isSearching
      );
    }

    return (
      this.props.results.length === 0 &&
      this.props.metadataResults.length === 0 &&
      this.props.bookStoreResults.length === 0 &&
      !(
        this.props.paginatedResults && this.props.paginatedResults.isSearching
      ) &&
      !this.props.isSearchingMetadata &&
      !this.props.isSearchingBridge
    );
  }

  render() {
    return (
      <SearchScreenContainer position={this.checkZeroResults()}>
        <PageTitle
          title={t("search.search-title", "Search Result", {
            result: this.props.query
          })}
        />
        <TitleWrapper>
          <SearchHeader>
            <Translation id="search.results-for" query={this.props.query} />
          </SearchHeader>
          <ExitButton
            href={this.props.redirectOnClose}
            onClick={this.exitSearch}
            naked
            colorBehindButton={ninja.getShade(11)}
          >
            <XLarge />
            <OffScreenComponent>
              <Translation id="base.exit" />
            </OffScreenComponent>
          </ExitButton>
        </TitleWrapper>
        {this.renderMainContent()}
        {this.renderStoreFooter()}
      </SearchScreenContainer>
    );
  }
}
const mapStateToProps = (state, props) => {
  const query = searchSelectors.getCurrentQuery(state);
  const flatResults = searchSelectors.getFlattenedCounts(state, query);
  const isbns = flatResults.map(i => i.isbn);
  const resultsByIsbn = flatResults.reduce((acc, i) => {
    acc[i.isbn] = i;
    return acc;
  }, {});
  const isNative = routerSelectors.isNative(state);
  const results = booksSelectors.getBooksByIsbn(state, isbns).map(book => {
    const r = resultsByIsbn[book.isbn];
    return { ...book, ...r };
  });

  const bridgeQuery = {
    active: false,
    search: query,
    size: BRIDGE_SEARCH_SIZE
  };
  const metadataResults = searchSelectors.getMetadataResults(state);
  const loadingPage = bridgeSelectors.getMaxLoadedOrLoadingPage(
    state,
    "assets",
    bridgeQuery
  );
  const bridgeResults = bridgeSelectors.getAssets(state, bridgeQuery);

  return {
    user: userSelectors.getUser(state),
    paginatedResults: searchSelectors.getCounts(state, query),
    isSearchingMetadata: searchSelectors.isSearchingMetadata(state),
    isSearchingBridge: bridgeSelectors.isAssetsFetching(state, bridgeQuery),
    isSearchingNewBridgePage: bridgeSelectors.isAssetsFetching(state, {
      ...bridgeQuery,
      page: loadingPage
    }),
    isSearchingBookStore: bridgeSelectors.isSearchingBookStore(state),
    isNative: isNative,
    metadataResults: metadataResults.concat(bridgeResults),
    bookStoreResults: bridgeSelectors.getBookStoreResults(state),
    results,
    query,
    isBridgeUser: bridgeSelectors.isBridgeUser(state),
    bridgeUserFetching: bridgeSelectors.isUserFetching(state),
    storeUrl: getStoreSearchUrl(state, query, {
      utm_medium: "bookshelf-empty-search",
      utm_campaign: query
    }),
    vitalsourceUrl: bridgeSelectors.getVitalsourceUrl(state),
    redirectOnClose:
      routerSelectors.getQueryParam(state, "redirectOnClose") || "/"
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  performSearch: query => dispatch(actions.countsSearch(query)),
  loadNextPage: query => dispatch(actions.loadNextPageOfCounts(query)),
  metadataSearch: (query, searchBridge) =>
    dispatch(actions.searchMetadata(query, searchBridge)),
  bookStoreSearch: query => dispatch(bridgeActions.searchBookStore(query)),
  searchBridge: query =>
    dispatch(
      bridgeActions.fetchAssets({
        page: 0,
        active: false,
        search: query,
        size: BRIDGE_SEARCH_SIZE
      })
    ),
  searchMoreBridge: query =>
    dispatch(
      bridgeActions.fetchMoreAssets({
        active: false,
        search: query,
        size: BRIDGE_SEARCH_SIZE
      })
    ),
  openSearchPanel: (isbn, title) =>
    dispatch(uiLibraryActions.openSearchPanel(isbn, title)),
  redirectToRoot: () => dispatch(routerActions.go("/"))
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchScreen);
